<template>
  <div class="header">
    <div class="row">
      <div class="left-side">
        <a :href="$webPath.index" class="logo-bd"></a>
      </div>
      <div class="right-side">
        <div class="nav">
            <a :href="$webPath.index">首页</a>
            <router-link :to="{name:'index'}">我要找车</router-link>
            <a :href="$webPath.aboutUs">关于我们</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.header {
  min-width: 1200px;
  height: @headerHeight;
  box-sizing: border-box;
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  .row {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
  }
  .left-side {
    height: 100%;
    display: inline-block;
    vertical-align: middle;
    .middle-center() {
      display: inline-block;
      vertical-align: middle;
    }
    &::after {
      content: "";
      height: 100%;
      .middle-center();
    }
    .logo-bd {
      .middle-center();
      width: 146px;
      height: 50px;
      .bgImage('logo.png';2);
      box-sizing: border-box;
    }
  }
  .right-side {
    float: right;
    height: 100%;
    .nav {
      height: 100%;
      a {
        display: inline-block;
        width: 120px;
        height: 100%;
        line-height: @headerHeight;
        text-align: center;
        font-size: 16px;
        color: #333;
         &.router-link-active {
           background-color: @theme-color;
           color: #fff;
        }
      }
    }
  }
 
}
</style>